import { Card, styled } from '@material-ui/core';
import { theme } from '@/theme/mui-theme';

export const SearchCard = styled(Card)({
  padding: theme.spacing(2),
  display: 'flex',
  columnGap: theme.spacing(2),
  cursor: 'pointer',
  boxShadow: theme.shadows[1],

  '&:hover': {
    boxShadow: theme.shadows[3],
  }
});

export const SearchCardContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.spacing(0)
});

export const SearchCardIcon = styled('div')({
  width: '50px',
  height: '50px',
  backgroundColor: theme.palette.primary.main,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white'
});

export const SearchCardDetails = styled('div')({
  fontSize: '12px',
  color: 'rgba(0, 0, 0, 0.38)'
});
